module.exports = __webpack_public_path__ + "img/17ne.dced09b4.svg";